module.exports = __webpack_public_path__ + "static/media/japanese.ea3fffac.jpg";